export const pastEvents = [
  {
    slug: 'eco-printing',
    emoji: '🍃',
    tag: 'Subtle Animal Saturdays',
    title: 'Plant Printing on Natural Fabric: A Hands-On Textile Masterclass',
    date: 'Saturday 18 July · 10am–4pm',
    duration: '6 hours',
    location: 'Randwick Sustainability Hub, Randwick, Sydney',
    price: '$250',
    max: 15,
    img: '/backgrounds/ecoprint-hero.png',
    heroImg: '/backgrounds/ecoprint.jpg',
    images: ['/backgrounds/ecoprint2.png'],
    desc: 'Step into the slow, meditative world of plant printing on fabric – an ancient-meets-modern textile art that uses the natural pigments, tannins, and textures found in leaves, flowers, and bark to create one-of-a-kind prints directly onto fabric. Led by Ilana Hoffman and Nikki Penny. No experience necessary.',
    includesSummary: [
      'All fabrics, mordants & plant specimens',
      'Your finished eco-printed pieces',
      'Light refreshments',
      'Printed plant guide & reference card',
    ],
    includes: 'All materials – fabrics, mordants, plant specimens and bundling supplies, your finished eco-printed pieces to take home, light refreshments, and a printed plant guide and reference card.',
    bring: 'All materials are provided. Optionally, bring a fabric or textile item from home you\'d like to print on, a plant or leaves you\'re curious to work with, and lunch for the day.',
    ticketUrl: 'https://events.humanitix.com/eco-printing-a-hands-on-textile-workshop',
  },
  {
    slug: 'pet-herbal-balm-making-july25',
    emoji: '🐾',
    tag: 'Subtle Animal Saturdays',
    title: 'Handcrafted Botanical Skincare For Pets',
    date: 'Saturday 11 July · 9:30am–12pm',
    duration: '2.5 hours',
    location: 'Randwick Sustainability Hub, Randwick, Sydney',
    price: '$125',
    max: 20,
    img: '/backgrounds/pet-herbal-balm-july25.png',
    heroPosition: 'top',
    heroHeight: '600px',
    imgPosition: 'top',
    desc: 'A hands-on workshop in plant-based animal care. You\'ll make a balm for your dog from scratch, learning the plants, the process, and the reasoning behind it, and leave with a finished tin ready to use on dry paws, rough noses, and the small irritations of everyday life. We begin with the plants themselves: calendula for its gentle anti-inflammatory action, beeswax for protection and structure, shea and jojoba to soften and restore. You\'ll learn not just what goes in, but why, so you can adapt, experiment, and keep making long after the workshop ends.',
    includesSummary: [
      'Hands-on balm making from scratch',
      'Finished herbal balm tin to take home',
      'Recipes to recreate at home',
      'All materials, tea & snacks',
    ],
    includes: 'A grounded introduction to pet-safe plants and what they do for animal skin. Hands-on balm making – you measure, blend, pour, and label your own tin. One finished herbal balm to take home (for dry paws, rough noses, minor skin irritations, and everyday paw protection). Recipes to recreate and adapt at home. All materials and equipment provided. Tea, something to eat, good company.',
    bring: 'All materials and equipment are provided. No experience needed. Note: dogs cannot attend due to hot oils and waxes. The balm made in this workshop is a cosmetic product for external use on dogs – it is not a veterinary treatment. For skin conditions, open wounds, or health concerns, please consult your vet.',
    ticketUrl: 'https://events.humanitix.com/handcrafted-botanical-skincare-for-pets-11-07-26',
  },
  {
    slug: 'mushroom-foraging-jul-5',
    soldOut: true,
    emoji: '🍄',
    tag: 'Day Trip',
    title: 'Mushroom Foraging Experience',
    date: 'Sunday 5 July · 12pm–3pm',
    duration: '3 hours',
    location: 'Hampton State Forest, NSW',
    price: '$90',
    max: 15,
    img: '/backgrounds/saffies.jpeg',
    desc: 'A guided walk through pine forest, identifying and foraging culinary mushrooms. We begin with a short grounding meditation then move slowly through the environment – learning to recognise abundance, understand ecological relationships, and harvest responsibly.',
    includesSummary: [
      'Guided forage through pine forest',
      'Shared foraged meal',
      'Recipes to take home',
      'Grounding meditation',
    ],
    includes: 'Expert guidance, a shared foraged meal, recipes to take home, and a grounding meditation.',
    bring: 'Comfortable shoes, weather-appropriate layers, a small basket or bag, water bottle.',
    ticketUrl: 'https://events.humanitix.com/mushroom-foraging-experience',
  },
  {
    slug: 'coastal-foraging-jul-4',
    soldOut: true,
    emoji: '🌊',
    tag: 'Subtle Animal Saturdays',
    title: 'Coastal Foraging Experience',
    date: 'Saturday 4 July · 11am–1.30pm',
    duration: '2½ hours',
    location: 'Sydney coastline, NSW',
    price: '$70',
    max: 15,
    img: '/backgrounds/coral-reef-underwater.jpg',
    desc: "A guided walk along the shoreline exploring edible and useful seaweeds and coastal species, shaped by tide, season, and respect for Country. Where possible, we'll prepare and share a simple meal by the sea.",
    includesSummary: [
      'Guided coastal foraging walk',
      'Shared foraged meal by the sea',
      'Recipes to take home',
      'Grounding meditation',
    ],
    includes: 'Expert guidance, a shared foraged meal, recipes to take home, and a grounding meditation.',
    bring: "Shoes you don't mind getting wet, layers, a small bag or basket, water bottle.",
    ticketUrl: 'https://events.humanitix.com/coastal-foraging-experience',
  },
  {
    slug: 'urban-foraging',
    soldOut: true,
    emoji: '🌿',
    tag: 'Subtle Animal Saturdays',
    title: 'Urban & Weed Foraging Walk',
    date: 'Saturday 13 June · 9.30am–12pm',
    duration: '2½ hours',
    location: 'Randwick Sustainability Hub, Randwick, Sydney',
    price: '$70',
    max: 20,
    img: '/backgrounds/urban-foraging.jpg',
    desc: 'A reframing of the everyday landscape. This workshop invites you to see familiar streets, parks, and overlooked corners differently – as places of resilience, nourishment, and quiet abundance. Perfect for beginners and the quietly curious.',
    includesSummary: [
      'Guided urban foraging walk',
      'Recipes to take home',
      'Grounding meditation',
    ],
    includes: 'Expert guidance, recipes to take home, and a grounding meditation.',
    bring: 'Comfortable walking shoes, a small bag or basket, water bottle.',
    ticketUrl: 'https://events.humanitix.com/urban-and-weed-foraging-walk',
  },
  {
    slug: 'nature-connection-sensory-play',
    emoji: '🌀',
    tag: 'Subtle Animal Saturdays',
    title: 'Nature Connection & Sensory Play',
    date: 'Saturday 6 June · 11am–1.30pm',
    duration: '2½ hours',
    location: 'Sydney, NSW',
    price: '$40',
    max: 20,
    img: '/backgrounds/tree-climb.jpg',
    desc: 'A playful, grounding experience designed to reconnect people with their senses, the landscape, and each other. Through gentle games, movement, and sensory invitations, we explore how to listen more closely to the natural world and to ourselves.',
    includesSummary: [
      'Guided sensory activities',
      'Nature-based games & movement',
      'Grounding meditation',
    ],
    includes: 'Guided sensory activities, nature-based games, and a grounding meditation.',
    bring: 'Comfortable clothes you can move in, water bottle, willingness to play.',
    ticketUrl: 'https://events.humanitix.com/nature-connection-and-sensory-play',
  },
  {
    slug: 'coastal-foraging',
    emoji: '🌊',
    tag: 'Subtle Animal Saturdays',
    title: 'Coastal Foraging Experience',
    date: 'Saturday 16 May · 11am–1.30pm',
    duration: '2½ hours',
    location: 'Sydney coastline, NSW',
    price: '$70',
    max: 15,
    img: '/backgrounds/coral-reef-underwater.jpg',
    desc: "A guided walk along the shoreline exploring edible and useful seaweeds and coastal species, shaped by tide, season, and respect for Country. Where possible, we'll prepare and share a simple meal by the sea.",
    includesSummary: [
      'Guided coastal foraging walk',
      'Shared foraged meal by the sea',
      'Recipes to take home',
      'Grounding meditation',
    ],
    includes: 'Expert guidance, a shared foraged meal, recipes to take home, and a grounding meditation.',
    bring: "Shoes you don't mind getting wet, layers, a small bag or basket, water bottle.",
    ticketUrl: 'https://events.humanitix.com/coastal-foraging-experience',
  },
  {
    slug: 'mushroom-foraging-may-6',
    emoji: '🍄',
    tag: 'Day Trip',
    title: 'Mushroom Foraging Experience',
    date: 'Wednesday 6 May · 12pm–3pm',
    duration: '3 hours',
    location: 'Hampton State Forest, NSW',
    price: '$90',
    max: 15,
    img: '/backgrounds/saffies.jpeg',
    desc: 'A guided walk through pine forest, identifying and foraging culinary mushrooms. We begin with a short grounding meditation then move slowly through the environment – learning to recognise abundance, understand ecological relationships, and harvest responsibly.',
    includesSummary: [
      'Guided forage through pine forest',
      'Shared foraged meal',
      'Recipes to take home',
      'Grounding meditation',
    ],
    includes: 'Expert guidance, a shared foraged meal, recipes to take home, and a grounding meditation.',
    bring: 'Comfortable shoes, weather-appropriate layers, a small basket or bag, water bottle.',
    ticketUrl: 'https://events.humanitix.com/mushroom-foraging-experience',
  },
  {
    slug: 'mushroom-foraging-may-10',
    emoji: '🍄',
    tag: 'Day Trip',
    title: 'Mushroom Foraging Experience',
    date: 'Sunday 10 May · 12pm–3pm',
    duration: '3 hours',
    location: 'Hampton State Forest, NSW',
    price: '$90',
    max: 15,
    img: '/backgrounds/saffies.jpeg',
    desc: 'A guided walk through pine forest, identifying and foraging culinary mushrooms. We begin with a short grounding meditation then move slowly through the environment – learning to recognise abundance, understand ecological relationships, and harvest responsibly.',
    includesSummary: [
      'Guided forage through pine forest',
      'Shared foraged meal',
      'Recipes to take home',
      'Grounding meditation',
    ],
    includes: 'Expert guidance, a shared foraged meal, recipes to take home, and a grounding meditation.',
    bring: 'Comfortable shoes, weather-appropriate layers, a small basket or bag, water bottle.',
    ticketUrl: 'https://events.humanitix.com/mushroom-foraging-experience',
  },
  {
    slug: 'herbal-balm-making',
    soldOut: true,
    emoji: '🌱',
    tag: 'Subtle Animal Saturdays',
    title: 'Handcrafted Botanical Skincare Workshop',
    date: 'Saturday 9 May · 9:30am–12pm',
    duration: '2.5 hours',
    location: 'Randwick Sustainability Hub, Randwick, Sydney',
    price: '$125',
    max: 20,
    img: '/backgrounds/balm-making.jpg',
    desc: 'A slow, hands-on experience crafting natural skincare products from scratch, made with locally foraged plants and locally harvested beeswax. Learn the plant medicine behind every ingredient you use.',
    includesSummary: [
      'All materials & locally sourced ingredients',
      'Expert guidance on plant medicine',
      'Finished herbal balm to take home',
    ],
    includes: 'All materials, expert guidance, your finished herbal balm to take home.',
    bring: 'Just yourself – all materials are provided.',
    ticketUrl: 'https://events.humanitix.com/herbal-balm-making-workshop',
  },
];
